import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import Title from '../../components/Title';
import RoutesUtils from '../../utils/routes';
import { DriveItemListOrigin } from '../DriveItemListPage/constants';

const mapStateToProps = (state: StoreState) => {
	const {
		routerParamsHistory,
		selection: { resources, notes },
	} = state;

	const hasClearButton = RoutesUtils.currentLocationIs(routerParamsHistory, DriveItemListOrigin.Selection) && resources.length + notes.length > 0;
	const hasBreadCrumbs = RoutesUtils.currentLocationIs(routerParamsHistory, DriveItemListOrigin.Folder);

	return { hasBreadCrumbs, hasClearButton };
};

export default connect(mapStateToProps)(Title);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Title/index.ts